import type { Event } from "@/types";
import { formatDate } from "@shared/utils";

interface EventInfoHeaderProps {
  event: Event;
  totalTickets: number;
  /**
   * Horario a mostrar. Si se pasa, reemplaza a `event.hour` (se usa para
   * mostrar solo el día de la localidad elegida durante el checkout).
   */
  hour?: string;
}

/**
 * Event info header molecule for checkout steps.
 * Image 115×115 + event name, date-hour, city-country, ticket count.
 */
export function EventInfoHeader({ event, totalTickets, hour }: EventInfoHeaderProps) {
  const displayHour = hour ?? event.hour;
  return (
    <div className="flex items-center gap-4" style={{ height: 115 }}>
      {/* Event image */}
      <img
        src={event.image ?? "/images/placeholder.png"}
        alt={event.name}
        className="rounded-lg object-cover"
        style={{ width: 115, height: 115 }}
      />

      {/* Event info */}
      <div className="flex min-w-0 flex-col justify-center gap-1">
        <span
          className="font-semibold text-primary-110 truncate"
          style={{ fontSize: 16 }}
        >
          {event.name}
        </span>
        <span className="text-primary-110" style={{ fontSize: 14 }}>
          {formatDate(event.dateevent)}
          {displayHour ? ` - ${displayHour}` : ""}
        </span>
        <span className="text-primary-110" style={{ fontSize: 14 }}>
          {totalTickets} ticket{totalTickets !== 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
}
